
import { Divider } from 'antd';
import PersonalLevyComponent from './PersonalLevyComponent';
import SkillsLevyComponent from './SkillLevyComponent';
import styles from './index.module.scss';

const OtherComponent = () => {

	return (
			<div className={styles['skillComponent']}>
				<SkillsLevyComponent
				/>
				<Divider
					dashed
					style={{ borderColor: '#BCBCBC', marginBottom: '4rem' }}
				></Divider>
				<PersonalLevyComponent
				/>
			</div>
	
	);
};

export default OtherComponent;
